module.exports = __webpack_public_path__ + "res/28-img_game_bg_q_t.6fd48cc56fbc96225f13aee45e558882.png";